import React from 'react';
import { Link } from 'react-router-dom';
import { Translate } from 'core/translate';
import { SvgIcon } from 'core/icons';
import { combineClassNames, Themed } from 'core/css';

const OptionMore = ({ to, analyticsKey, analyticsKey2 }) => {
  return (
    <Themed
      cadillac="button button--link button--flex button--condensed"
      chevrolet="button button--link button--condensed"
      gmc="button button--link button--condensed">
      {theme => (
        <div className="option__more">
          <Link
            to={to}
            className={combineClassNames(
              'option__more-link',
              'stat-text-link',
              theme
            )}
            data-dtm={analyticsKey}
            data-dtm2={analyticsKey2}>
            <span className="button__text">
              <Translate value="show.more" />
            </span>
            <SvgIcon
              name="chevron-right"
              className="button__icon option__chevron-right--hide"
            />
          </Link>
          <Link
            to={to}
            className="stat-image-link"
            data-dtm={analyticsKey}
            data-dtm2={analyticsKey2}>
            <SvgIcon name="info" />
          </Link>
        </div>
      )}
    </Themed>
  );
};

export default OptionMore;
